/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AllergenRecipeModalUpdateMutationVariables = {|
  id: string,
  allergen: string,
|};
export type AllergenRecipeModalUpdateMutationResponse = {|
  +recipeUpdateAllergen: ?{|
    +recipeAllergen: ?{|
      +allergen: {|
        +id: string,
        +name: string,
      |}
    |}
  |}
|};
export type AllergenRecipeModalUpdateMutation = {|
  variables: AllergenRecipeModalUpdateMutationVariables,
  response: AllergenRecipeModalUpdateMutationResponse,
|};
*/


/*
mutation AllergenRecipeModalUpdateMutation(
  $id: ID!
  $allergen: ID!
) {
  recipeUpdateAllergen(input: {id: $id, allergen: $allergen}) {
    recipeAllergen {
      allergen {
        id
        name
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "allergen",
    "type": "ID!"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "allergen",
        "variableName": "allergen"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AllergenNode",
  "kind": "LinkedField",
  "name": "allergen",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllergenRecipeModalUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipeUpdateAllergenPayload",
        "kind": "LinkedField",
        "name": "recipeUpdateAllergen",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeAllergenNode",
            "kind": "LinkedField",
            "name": "recipeAllergen",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllergenRecipeModalUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RecipeUpdateAllergenPayload",
        "kind": "LinkedField",
        "name": "recipeUpdateAllergen",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeAllergenNode",
            "kind": "LinkedField",
            "name": "recipeAllergen",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AllergenRecipeModalUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AllergenRecipeModalUpdateMutation(\n  $id: ID!\n  $allergen: ID!\n) {\n  recipeUpdateAllergen(input: {id: $id, allergen: $allergen}) {\n    recipeAllergen {\n      allergen {\n        id\n        name\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '41261e5b912c711c31070282d321de04';

module.exports = node;
